<template>
  <button
    @click="findProperties"
    :class="[
      'flex items-center justify-center md:w-40 md:h-[48px] h-[36px] md:text-base text-sm px-2 py-1 rounded-lg text-white',
      loading
        ? 'bg-gray-300 cursor-not-allowed'
        : 'bg-primary hover:bg-[#910811]',
    ]"
    :disabled="loading"
  >
    Find
  </button>
</template>

<script>
export default {
  name: "FindButton",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    findProperties() {
      this.$emit("find-properties");
    },
  },
};
</script>

<style scoped>
/* Button styling */
</style>
